// extracted by mini-css-extract-plugin
export default {"hover":"style_hover__oany+","linear":"style_linear__RQphR","tagHover":"style_tagHover__-mXBO","mobileTitle":"style_mobileTitle__VJ294","fontColor":"style_fontColor__iqJrp"};